import React from "react";
import "./faqs.css";
import QuestionsTab from "./QuestionsTab";

function FAQs() {
  return (
    <div className="faq-wrapper">
      <div className="faq-heading">
        In case you feel lost,
        <span style={{ color: "#6D2FEC", paddingLeft: ".5rem" }}>
          {" "}
          We’re here
        </span>
      </div>
      <div className="faq-questions-tab">
        <QuestionsTab
          ques={"Will there be challenges while integration?"}
          ans={
            "Our APIs are built to ensure that integration is straightforward and seamless. They are designed as plug-and-play solutions, making it easy for developers to integrate them into existing systems."
          }
        />
        <QuestionsTab
          ques={"How accurate is the data you're fetching? "}
          ans={
            "The accuracy of the data fetched by our APIs is a top priority. We source data from authorized and verified sources, and our systems are designed to fetch the necessary information, allowing our clients to perform validations on their end."
          }
        />
        <QuestionsTab
          ques={"Can APIs be combined?"}
          ans={
            "Absolutely! We can customize and combine APIs tailored to your specific requirements."
          }
        />
        <QuestionsTab
          ques={"Is there a testing environment available?"}
          ans={
            "We offer a sandbox environment where you can test the API functionality thoroughly before going live. This helps identify any potential issues without affecting real data."
          }
        />
        <QuestionsTab
          ques={"How secure are your APIs?"}
          ans={
            "Our APIs are built with robust security measures, including encryption and secure authentication methods. We comply with industry standards to protect your data and transactions."
          }
        />
      </div>
    </div>
  );
}

export default React.memo(FAQs);
